import React from 'react'
import css from './section.module.css'
const Card = ({feature}) => {
    const {image, bg, title, desc} = feature
  return (
    <div className={css.card} >
        <h3><span style={{backgroundColor: bg}}>{image}</span></h3>
        <h4>{title}</h4>
        <p>{desc}</p>
    </div>
  )
}

export default Card